<template>
  <div class="container">
    <ith-grid-platform-skeleton v-show="moviesNewUpdate == null" />
    <template v-for="item in moviesNewUpdate">
      <div :key="item.platform">
        <div class="title">
          <figure v-if="item.imgPlatform != null" class="image-platform">
            <img :src="item.imgPlatform" />
          </figure>
          <div v-else class="image-platform movie--item skeleton"></div>

          <div class="title-linea">
            <div class="title-linea-title">{{ item.platform }}</div>
            <div class="linea"></div>
          </div>
        </div>

        <ith-movies-grid-updates-detail
          :items="item.updates"
          :platform="item.platform"
        />
      </div>
    </template>
    <div v-show="moviesNewUpdate == ''">
      <ith-no-results />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState([
    "platforms_temp",
    "generalGenres",
    "generalLanguage",
    "generalMonths",
    "user",
  ]),
  data: () => ({
    paramsUpdate: {
      languages: "",
      genres: "",
      country: "USA",
      months: "",
    },
    moviesNewUpdate: null,
    items: [],
    months: [],
    el: { id: "", val: "" },
    count: 0,
  }),

  mounted() {
    this.getMonths();
    this.paramsUpdate.genres = this.generalGenres;
    this.paramsUpdate.languages = this.generalLanguage;
    this.getUpdates();
  },

  watch: {
    generalMonths() {
      if (this.generalMonths != "")
        this.paramsUpdate.months = this.generalMonths;
      else this.getMonths();

      this.getUpdates();
    },
    generalGenres() {
      this.paramsUpdate.genres = this.generalGenres;
      this.getUpdates();
    },
    generalLanguage() {
      this.paramsUpdate.languages = this.generalLanguage;
      this.getUpdates();
    },
    platforms_temp() {
      this.imagePlatfom();
    },
    "user.country": function () {
      this.getUpdates();
    },
  },
  methods: {
    getUpdates() {
      this.paramsUpdate.country = this.user.country;
      this.count++;
      let validador = this.count;
      (this.moviesNewUpdate = null),
        this.$Parse.Cloud.run("getUpdates", this.paramsUpdate)
          .then((res) => {
            if (validador == this.count) {
              this.moviesNewUpdate = res.updates.map(function callback(
                currentValue
              ) {
                currentValue.imgPlatform = null;

                currentValue.updates = currentValue.updates.map(function (obj) {
                  const searchRegExp = /\s/g;
                  const replaceWith = "-";
                  obj.show.slug = obj.show.title.replace(
                    searchRegExp,
                    replaceWith
                  );
                  return obj;
                });

                return currentValue;
              });
            }
            this.imagePlatfom();
            let items = res.weekReleases.map(function callback(currentValue) {
              currentValue.updates = currentValue.updates.map(function (obj) {
                const searchRegExp = /\s/g;
                const replaceWith = "-";
                obj.show.slug = obj.show.title.replace(
                  searchRegExp,
                  replaceWith
                );
                return obj;
              });

              return currentValue;
            });
            this.$store.commit("SET_RELEASING_THIS_WEEK", items);
          })
          .catch((error) => {
            console.log(error);
          });
    },
    imagePlatfom() {
      if (this.platforms_temp != null && this.moviesNewUpdate != null) {
        const plataforms = this.platforms_temp;
        this.moviesNewUpdate = this.moviesNewUpdate.map(function callback(
          currentValue
        ) {
          const i = plataforms.findIndex(
            (el) => el.name == currentValue.platform
          );
          if (i != -1) currentValue.imgPlatform = plataforms[i].imageUrl;
          return currentValue;
        });
      }
    },

    getMonths() {
      let month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

      let d = new Date();
      let n = d.getMonth();
      let y = d.getFullYear();
      for (let index = n; index < n + 4; index++) {
        let el = { id: "", val: "" };
        if (index === 12) {
          let m = y + 1;
          el.id = "01/" + m;
          el.val = month[0];
          this.items.push(el);
          this.months.push(el.id);
        } else if (index === 13) {
          let m = y + 1;
          el.id = "02/" + m;
          el.val = month[1];
          this.items.push(el);
          this.months.push(el.id);
        } else if (index === 14) {
          let m = y + 1;
          el.id = "03/" + m;
          el.val = month[2];
          this.items.push(el);
          this.months.push(el.id);
        } else {
          let m = index + 1;
          el.id = m + "/" + y;
          el.val = month[index];
          this.items.push(el);
          this.months.push(el.id);
        }
      }
      this.paramsUpdate.months = this.months.toString();
    },
  },
};
</script>

<style scoped>
.container {
  min-height: 40vh;
}
.title {
  display: grid;
  grid-template-columns: 90px auto;
  justify-content: stretch;
  column-gap: 15px;
  align-items: center;
  height: 60px;
  padding: 20px 0;
}

.banner {
  margin-top: 50px;
}

.subtitle {
  font-size: 0.8rem;
  padding: 0px 50px 20px 60px;
  margin-top: 0px;
}

.image-platform {
  margin: 0;
}
.image-platform > img {
  border-radius: 10px;
  height: 50px;
  width: 70px;
  object-fit: cover;
}

.skeleton {
  height: 50px;
  width: 70px;
  background-color: #314c75;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  display: block;
}

.title-linea {
  width: 100%;
  display: flex;
  height: 60px;
  column-gap: 20px;
  align-items: top;
}

.title-linea-title {
  align-self: center;
  white-space: nowrap;
  font-size: 1.2em;
  text-transform: uppercase;
}
.linea {
  width: 100%;
  height: 50%;
  border-bottom: 1px solid #738092;
}

@media (min-width: 1500px) {
  .container {
    min-height: 53vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}
@media (max-width: 600px) {
  .title-linea-title {
    font-size: 0.8rem;
  }
  .image-platform {
    margin-left: 10px;
  }
}
</style>
